export default __webpack_public_path__ + "static/media/fruits_avacado.59195a47.jpg";